import {Component, OnInit, PLATFORM_ID, Inject, Input} from '@angular/core';
import { NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';
import { inject } from '@angular/core/testing';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { Globalvar } from '../../classes/globalvar';
import { DonorprofileService } from '../../services/donorprofile.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router'
declare var $: any;

//New Import
import { UserService } from '../../api/user.service'
import { PaymentService } from '../../api/payment.service'
import { HelperService,ErrorClass } from '../../api/helper.service'

@Component({
  selector: 'app-anonnymous-donation',
  templateUrl: './anonnymous-donation.component.html',
  styleUrls: ['./anonnymous-donation.component.css']
})
export class AnonnymousDonationComponent implements OnInit {
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private paymentAPI:PaymentService,
    private userAPI:UserService,
    private help:HelperService,
    private aRoute:ActivatedRoute,

    public router: Router,
    private donorprofileDetails: DonorprofileService,
    private http: HttpClient,
    ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
    }

    private token = '';
    public ERROR_NEW_PASSWORD = false;
    NewPassword(Current, confirm, event) { 
      //console.log(Current, event.target.value)    
      if (Current && event.target.value) {
        if (Current !== event.target.value) {
          this.ERROR_NEW_PASSWORD = false;
        } else {
          this.ERROR_NEW_PASSWORD = true;
        }
        //console.log(this.ERROR_NEW_PASSWORD)
      }else{
        this.ERROR_NEW_PASSWORD = false;
      }
      if (confirm && event.target.value) {
        if (confirm == event.target.value) {
          this.ERROR_CONFIRM_PASSWORD = false;
        } else {
          this.ERROR_CONFIRM_PASSWORD = true;
        }
        //console.log(this.ERROR_CONFIRM_PASSWORD)
      }
    }
  
    public ERROR_CONFIRM_PASSWORD = false;  
    ConfirmPassword(val, event) {  
      //console.log(val, event.target.value)  
      if (val && event.target.value) {
        if (val == event.target.value) {
          this.ERROR_CONFIRM_PASSWORD = false;
        } else {
          this.ERROR_CONFIRM_PASSWORD = true;
        }
        //console.log(this.ERROR_CONFIRM_PASSWORD)
      }else{
        this.ERROR_CONFIRM_PASSWORD = false;
      }
    }
    
    public DonorID;
    public CURRENT_PASSWORD;
    public NEW_PASSWORD;
    public CONFIRM_PASSWORD;
  
  
  
  
    public currentPassword;
  
    ChangePassword(form) {
      var thisO = this
      //console.log(form)
      if (form.valid && form.value.CP_New_Password == form.value.CP_Confirm_Password) {
        
        var body = {
          'token' : this.token,
          'password' : this.NEW_PASSWORD,
          'password_confirmation' : this.CONFIRM_PASSWORD
        }
  
        this.userAPI.forgotPasswordUpdate(body).subscribe(
          (data) => {
             this.help.msgbox("Change Password","Success")
          },
          (err:ErrorClass) => {
            this.help.msgboxError("Error",err.error_message)
          }
        )
        
        
      }
      //console.log("Change Password Form", form)
    }
  
    
  @Input() donationAmount = 500

  fm_id = 0;
  order_status = 'pending';
  fm_title = '';
  ngOnInit() {
    //if(this.isBrowser)
    this.aRoute.queryParams.subscribe(
      (params) => {
         if(params['fm_id']  === undefined){
           this.help.msgboxError("Validation Error","Token is required").then(
             () => {
              this.router.navigate(['/']);
             }
           )
           
         }else{
            this.fm_id =params['fm_id']
            this.paymentAPI.fundraiserTitle(this.fm_id).subscribe(
              (data:any) => {
                 this.fm_title = data.title
              }
            )
         }

         if(params['order_status'] !== undefined){
          this.order_status = params['order_status']
          this.ref_no = params['ref_no']
         }

         

      }
    )
  } 
  
ref_no = ''
is_loading = false
sday = 0
smonth=0
syear =0
secureHash ='';
submitDonation(){
   const body = {
     'amount' :this.donationAmount,
     'fundraiser_master_id' : this.fm_id
   }
   this.is_loading = true
   this.paymentAPI.anonymousDonation(body).subscribe(
     (data:any) => {
        this.ref_no = data.ref_no
        this.sday = data.sday
        this.smonth = data.smonth
        this.syear = data.syear
        this.secureHash = data.secureHash
        this.is_loading = false

        setTimeout(
          () => {
            document.forms["pesopayForm"].submit();
          }, 50
        )

     },
     (err:ErrorClass) => {
       this.help.msgboxError("Error",err.error_message)
       this.is_loading = false
     }
   )   
}


}




// function contactList(str) {
//   console.log(str);
//       $("#tbl").empty();
//       var datajson = JSON.parse(str);
//       $("#tbl").append('<thead><tr><th>Full Name</th><th>Email ID</th></tr></thead><tbody>');
//       $.each(datajson, function (index, data) {
//           $("#tbl").append("<tr><td>" + data.FullName + "</td><td>" + data.Email + "</td></tr>");
//       });
//       $("#tbl").append('</tbody>');
// }
